import { IAppState } from '../../redux';
import { EPlacingType } from '../../redux/reducers';
import { selectIsPackagesAvailable } from './selectIsPackagesAvailable';

export function selectIsPackagesVisible(state: IAppState): boolean {
  const { selectedPlacingType } = state.publishTerms;

  const isPackagesAvailable = selectIsPackagesAvailable(state);

  return isPackagesAvailable && selectedPlacingType === EPlacingType.package;
}
